import React from 'react';
import autoBind from 'react-autobind';
import { Row, Col } from 'react-bootstrap';
import GridFilterBase from './grid.filter.base';

const I = {
  CPFCNPJ: 0,
};

class GridFilter extends GridFilterBase {
  constructor(props) {
    super(props, {
      contains: { title: 'CPF / CNPJ:', type: 'text', operation: 'contains' },
    });

    autoBind(this);
  }

  getDefaultInputValues() {
    return {
      isNotCase: false,
      isNot: false,
      value: '',
    };
  }

  handleChangeValue(index, field, prop) {
    let { column } = this.props;

    return async (e) => {
      e.target[prop || 'value'] = this.cpfCnpjFormatter(e.target[prop || 'value']);

      column.inputs[index][field] = e.target[prop || 'value'];
      this.updateContextColumn(column);
    };
  }

  async isValid() {
    const { column } = this.props;
    const { inputs } = column;
    const value = inputs[I.CPFCNPJ].value;

    const rawValue = value ? value.replace(/[^\d]+/g, '') : '';

    if (rawValue.length == 0 || rawValue.length == 11 || rawValue.length == 14) {
      return true;
    } else {
      _alert.warning('O tamanho com campo deve ser equivalente ao de um CPF ou CNPJ.');
      return false;
    }
  }

  handleIsNot(e) {
    let { column } = this.props;
    let isNot = e.target.checked;
    column.inputs.forEach((x) => (x.isNot = isNot));
    this.updateContextColumn(column);
  }

  cpfCnpjFormatter(value) {
    let rawValue = value.replace(/[^\d]+/g, '');
    if (rawValue.length > 14) {
      rawValue = rawValue.substring(0, 14);
    }
    if (rawValue.length <= 11) return this.cpfFormatter(rawValue);
    if (rawValue.length > 11) return this.cnpjFormatter(rawValue);
  }

  cpfFormatter(value) {
    if (value.length <= 3) return value.replace(/^(\d{3})*/, '$1');
    if (value.length > 3 && value.length <= 6) return value.replace(/^(\d{3})(\d{3})*/, '$1.$2');
    if (value.length > 6 && value.length <= 9) return value.replace(/^(\d{3})(\d{3})(\d{3})*/, '$1.$2.$3');
    if (value.length > 9 && value.length <= 11) return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4');
  }

  cnpjFormatter(value) {
    if (value.length <= 12) return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})*/, '$1.$2.$3/$4');
    if (value.length > 12) return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})*/, '$1.$2.$3/$4-$5');
  }

  render() {
    const { column } = this.props;
    const { inputs } = column;

    if (!inputs) return null;

    return (
      <ul>
        {inputs.map(this.renderInput)}
        <div className="filterColunm mt-2">
          <label className="checkbox">
            <input
              className="mt-0"
              type="checkbox"
              checked={(inputs[0] || {}).isNot || false}
              onChange={this.handleIsNot}
            />{' '}
            Registros não coincidentes
          </label>
        </div>
      </ul>
    );
  }

  renderInput(input, index) {
    const { hash } = this.props;
    return (
      <li className="filterLine" key={index}>
        <div className="filterColunm">
          <Row>
            <Col lg="12">
              <input
                className="form-control"
                name={hash}
                placeholder={'___.___.___-__'}
                value={input.value}
                onChange={this.handleChangeValue(index, 'value')}
              />
            </Col>
          </Row>
        </div>
      </li>
    );
  }
}

export default GridFilter;
